import React from 'react';
import { ConfigProvider } from 'antd';

const GDTheme: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ConfigProvider theme={{ token: {
    colorPrimary: '#2D9CC9', colorInfo: '#2D9CC9', colorTextBase: '#031323',
    borderRadius: 10, controlHeight: 40, fontSize: 14,
  }, components: { Button: { controlHeight: 44 }, Input: { controlHeight: 44 } } }}>
    {children}
  </ConfigProvider>
);

export default GDTheme;
